import classnames from 'classnames/bind'
import React from 'react'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'

import { LinkProps } from '@unlikelystudio/react-abstract-components'

import GridListNav from '~/components/UI/GridListNav'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type HeroGridListProps = {
  className?: string
  childrenClassName?: string
  title?: string
  links?: LinkProps[]
  children?: JSX.Element | JSX.Element[]
}

function HeroGridList({
  className,
  childrenClassName,
  title,
  links,
  children,
}: HeroGridListProps) {
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const titleStyle = useStyle({ textPreset: GlobalTextPreset.Title40SangBleu })

  return (
    <div className={cx(css.HeroGridList, className)}>
      <div className={cx(css.content, gridStyle)}>
        <div className={css.left}>
          {title && <h1 className={cx(css.title, titleStyle)}>{title}</h1>}
        </div>
        {children && (
          <div className={cx(css.center, childrenClassName)}>{children}</div>
        )}
        {links?.length > 0 && (
          <div className={css.right}>
            <GridListNav links={links} className={css.links} />
          </div>
        )}
      </div>
    </div>
  )
}

HeroGridList.defaultProps = {}

export default HeroGridList
